import { BASE_URL } from '../authService/urls';

export const AUTH_SESSIONS_URL = `${BASE_URL}/sessions`;

export const authTags = {
  userSessions: 'userSessions',
} as const;
